import React from 'react'
import { connect } from 'react-redux'
import documentStyles from './../documents.scss'
import cs from 'classnames'
import i18n from 'lib/i18n'

// variables out of module
const _ = i18n('dsdocuments')

/**
 * This module render a button witch can be used to link one or more dsDocuments from a package to a contract or upload these documents dsDocuments
 */

export default class DsPackageLinkAndUploadButton extends React.Component {
    static propTypes = {
        dsPackage: React.PropTypes.object,
        openLinkAndUploadWizard: React.PropTypes.func,
        key: React.PropTypes.string,
    }

    constructor(props) {
        super(props)
        this.state = {}
    }

    /**
     * This function handle the onclick on action button for a DSDocument
     * @param {*} dsPackage
     */
    onDSDocumentActionClick(dsPackage) {
        // no document cancel action
        if (!dsPackage) {
            return false
        }

        return this.openLinkAndUploadWizard(dsPackage)
    }

    /**
     *
     * @param {*} dsPackage
     */
    openLinkAndUploadWizard(dsPackage) {
        this.props.openLinkAndUploadWizard(dsPackage)
    }

    /**
     * Main render function
     */
    render() {
        const { key, dsPackage } = this.props
        const hasUnUploadedDocuments = dsPackage && dsPackage.dsDocuments && dsPackage.dsDocuments.some(oneDocument => !oneDocument.uploadedToOracle && !oneDocument.isAttachment)
        return (
            <div className={cs(documentStyles.grow)} key={key}>
                {(hasUnUploadedDocuments && (!dsPackage.mustBeSigned || (dsPackage.mustBeSigned && dsPackage.hasFinishStatus) || dsPackage.requireLinking) && !dsPackage.isEditable) &&
                    <button className={cs(documentStyles.greenButton, documentStyles.greenButtonDsList, "enabled", documentStyles.grow)
                    }
                        onClick={(ev) => {
                            ev.stopPropagation()
                            return this.onDSDocumentActionClick(dsPackage)
                        }}
                    >
                        {dsPackage.requireLinking ? _("linkContract") : _("uploadDocument")}
                    </button >

                }

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/DSDocuments/linkToContractAndUploadDocuments/DsPackageLinkAndUploadButton.jsx